import Section from "../section/Section";
import ForWhomCard from "./components/ForWhomCard";
import {Localised} from "../../../../common/types";
import {getCurrentLang} from "../../../../common/utils/lang";

export interface IForWhom {
    category: string,
    reasons: string[],
    img: string
}
const forWhoms:Localised<IForWhom>[] = require("./forWhom.json");

const ForWhomSection = () => {
    const activeLang = getCurrentLang();
    const cards = forWhoms.map((forWhom, i) => <ForWhomCard key={`fh${i}`} forWhom={forWhom[activeLang]}/>);

    return (
        <Section titlePath="home.for-whom.title">
            <ul className="flex flex-col gap-[50px] sm:gap-[30px] md:flex-row max-md:items-center text-[#252429] ">
                {cards}
            </ul>
        </Section>
    )
};

export default ForWhomSection;
